import { render, staticRenderFns } from "./OkCancel.vue?vue&type=template&id=6ed50b70&scoped=true"
import script from "./OkCancel.vue?vue&type=script&lang=js"
export * from "./OkCancel.vue?vue&type=script&lang=js"
import style0 from "./OkCancel.vue?vue&type=style&index=0&id=6ed50b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed50b70",
  null
  
)

export default component.exports